<template>
  <div
    v-if="loading"
    id="page-loading"
    class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-base-100 transition-opacity"
    :class="{ 'opacity-0 pointer-events-none': !isActive, 'opacity-100 pointer-events-auto': isActive }"
  >
    <span class="loading loading-dots loading-xl" />
  </div>
</template>

<script setup>
const nuxtApp = useNuxtApp()
const loading = ref(false)
const isActive = ref(false)

watch(isActive, (newValue) => {
  if (!newValue) {
    setTimeout(() => loading.value = false, 500)
  }
})

nuxtApp.hook('page:start', () => {
  loading.value = true
  isActive.value = true
})
nuxtApp.hook('page:finish', () => {
  isActive.value = false
})
</script>
